export const SET_EXTENSIONS = 'extensions/SET_EXTENSIONS';

export const setExtensions = payload => ({
  type: SET_EXTENSIONS,
  payload,
});
